<template>
  <div class="flex flex-col justify-between h-full">
    <div class="mt-[199px]">
      <img :src="imgSrc" alt="Logo" class="w-1/2 max-w-[400px] mx-auto"/>
  
      <h1 class="text-white text-2xl font-semibold leading-[26px] mt-[39px] text-center">{{ title }}</h1>
      <p class="text-muted-gray font-medium text-xl leading-[26px] mt-6 text-center px-5">{{ description }}</p>
    </div>
    
    <VButton
      class="mt-6 mb-6"
      type="solid"
      title="Voltar"
      :callback="async () => emit('go-back')"
    />
  </div>
</template>

<script setup lang="ts">
import VButton from '@/components/Button/VButton.vue';

interface Props {
  imgSrc: string;
  title: string;
  description: string;
}

defineProps<Props>();

const emit = defineEmits(["go-back"]);
</script>